import update from 'immutability-helper';
import get from 'lodash/get';
import createMappedReducer from 'src/common/reducers/utils/createMappedReducer';
import { CONFIG_INIT, FETCH_CONFIG } from '../actions/config';
import { fulfilled } from './utils/asyncActionNameSuffixes';

function mapConfigData(state, action) {
  return update(state, {
    $set: action.config || get(action, 'payload.config', {}),
  });
}

export const config = createMappedReducer(
  {},
  {
    [CONFIG_INIT]: mapConfigData,
    [fulfilled(FETCH_CONFIG)]: mapConfigData,
  },
);
